import React from "react";
import '../../styles/startbutton.css';
import { useNavigate } from "react-router-dom";

const StartButton = () => {

    const navigate = useNavigate();

    return (
<div class="container opacity-fade-in-3" onClick={() => navigate('/tutorials/foundation')}>
    <div class="press-start">
        <div class="start-button">
            <div class="inner-circle"></div>
            <div class="outer-circle"></div>
        </div>
        <div class="marquee">
            <div class="letter">P</div>
            <div class="letter">R</div>
            <div class="letter">E</div>
            <div class="letter">S</div>
            <div class="letter">S</div>
            <div class="letter">S</div>
            <div class="letter">T</div>
            <div class="letter">A</div>
            <div class="letter">R</div>
            <div class="letter">T</div>
            <div class="letter">P</div>
            <div class="letter">R</div>
            <div class="letter">E</div>
            <div class="letter">S</div>
            <div class="letter">S</div>
            <div class="letter">S</div>
            <div class="letter">T</div>
            <div class="letter">A</div>
            <div class="letter">R</div>
            <div class="letter">T</div>
        </div>
    </div>
</div>
    );
};

export default StartButton;